import React from "react"
import {DatePicker} from "antd"
import {Icon} from "components/Icon"
import cx from "classnames"
import styles from "./BaseDatePicker.module.css"
import {useModel} from "hooks"
import moment from "moment"
import {toDateOnlyMoment, toDateOnlyString} from "helpers"
import {getAntdDatePickerLocale} from "helpers/antdWeekStart"

const {RangePicker} = DatePicker

type RangePickerComponentsProps = {[key in string]: any}

export type BaseRangePickerProps = RangePickerComponentsProps & {
    value?: any
    onChange?: any
    className?: string
    format?: string
    error?: boolean
    dateOnly?: boolean
    disabled?: boolean
    readOnly?: boolean
    suffixIcon?: JSX.Element
    disabledDate?: (currentDate: any) => boolean
}

export function BaseRangePicker(props: BaseRangePickerProps) {
    const model = useModel()
    const {onChange, className, error, format, value, dateOnly = false, locale: localeProp, ...rest} = props
    const currentUserDateFormat = model && model.getUserDateFormat && model.getUserDateFormat()
    const startWeekOn = model?.getStartWeekOn?.() ?? 0
    const pickerLocale = localeProp || getAntdDatePickerLocale(startWeekOn)
    const pickerValue: [moment.Moment | null, moment.Moment | null] | null = value?.length
        ? dateOnly
            ? [toDateOnlyMoment(value[0]), toDateOnlyMoment(value[1])]
            : [moment(value[0]), moment(value[1])]
        : null

    return (
        <RangePicker
            key={`rangepicker-${startWeekOn}`}
            onChange={(dates, dateStrings) => {
                if (!dateOnly) {
                    onChange?.(dates, dateStrings)
                    return
                }

                onChange?.(dates?.length ? [toDateOnlyString(dates[0]), toDateOnlyString(dates[1])] : null, dateStrings)
            }}
            className={cx(styles.datePicker, className, {[styles.error]: error})}
            suffixIcon={
                <div className={styles.calendarIconWrap}>
                    <Icon icon="CALENDAR_INPUT" color="#fff" />
                </div>
            }
            value={pickerValue}
            format={format || currentUserDateFormat || "MM/DD/YYYY"}
            {...rest}
            locale={pickerLocale}
        />
    )
}
